import { render, staticRenderFns } from "./AttachmentList.vue?vue&type=template&id=408bd322&scoped=true&"
import script from "./AttachmentList.vue?vue&type=script&lang=js&"
export * from "./AttachmentList.vue?vue&type=script&lang=js&"
import style0 from "./AttachmentList.vue?vue&type=style&index=0&id=408bd322&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "408bd322",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VDataTable,
  VIcon,
})
